<template>
  <div class="ui-work-item">
    <div class="work-item-wrapper" @click="handleJumpDetail">
      <div class="cover-wrapper">
        <img v-lazy="workItem.cover" />
        <WorkTypeTag v-if="workItem.worksType" :bgColor="workItem.worksType.color">{{ workItem.worksType.typeName }}</WorkTypeTag>
        <i class="icon-play" v-if="workItem.videos && workItem.videos.length > 0"></i>
        <SortTag v-if="showOrderNum && workItem.orderNo" :orderNum="workItem.orderNo" />
      </div>
      <div class="work-info">
        <div class="topic-title">{{ workItem.title }}</div>
        <span class="reportor-info gray">
          <span class="reportor-name" v-if="workItem.userName" :class="!userUnit ? 'only-name' : ''">{{ workItem.userName }}</span>
          <i class="icon icon-point" v-if="workItem.userName && userUnit"></i>
          <span class="reportor-school" v-if="userUnit">{{ userUnit }}</span>
        </span>
        <span class="guide-teacher gray" v-if="workItem.advisor">
          <span class="label">指导老师</span>
          <span class="guide-teacher-name">{{ workItem.advisor }}</span>
        </span>
      </div>
      <nf-praise
        :worksId="workItem.id"
        :hasPraised="workItem.like"
        @refreshLogin="handleRefreshWorkList"
        @resfresPraise="handlePraise"
        @backPraise="handleBackPraise"
        v-if="!hidePraise"
      >
        <div class="praise-wrapper">
          <div class="heart-wrapper">
            <transition name="fade-toggle">
              <span class="icon icon-heart active" v-if="workItem.like" key="iconPraiseRed"></span>
              <span class="icon icon-heart" key="iconPraiseWhite" v-else></span>
            </transition>
          </div>
          <span class="praise-count">{{ workItem.likeNum }}</span>
        </div>
      </nf-praise>
    </div>
  </div>
</template>

<script>
import NfPraise from "@/components/NfPraise"
import WorkTypeTag from "@/components/WorkTypeTag"
import SortTag from "./SortTag"
import resolveUserUnit from "@/utils/resolveUserUnit"
import { mapMutations, mapGetters } from "vuex"

export default {
  name: "uiWorkItem",
  props: {
    workItem: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number
    },
    showOrderNum: {
      type: Boolean,
      default: false
    },
    beforeJumpDetail: {
      type: Function,
      default() {
        return null
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    ...mapMutations({
      setworkDetail: "workDetail/setworkDetail",
      setWorkDetailIndex: "workDetail/setWorkDetailIndex"
    }),
    handlePraise() {
      this.$emit("resfresPraise", { index: this.index, workItem: { like: true, likeNum: this.workItem.likeNum + 1 } })
    },
    handleBackPraise() {
      this.$emit("resfresPraise", { index: this.index, workItem: { like: false, likeNum: this.workItem.likeNum - 1 } })
    },
    handleJumpDetail() {
      // this.setworkDetail({ ...this.workItem })
      this.beforeJumpDetail && this.beforeJumpDetail()
      this.setWorkDetailIndex(this.index)
      this.$router.push({ path: "/workDetail", query: { workId: this.workItem.id } })
    },
    handleRefreshWorkList() {
      this.$emit("refreshWorkList")
    }
  },
  components: {
    NfPraise,
    WorkTypeTag,
    SortTag
  },
  computed: {
    ...mapGetters({
      hidePraise: "activityInfo/hidePraise"
    }),
    userUnit() {
      return resolveUserUnit(this.workItem.defaultOpt)
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-work-item {
  padding: 0.38rem 0 0.36rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #eeeeee;
  .work-item-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cover-wrapper {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.25rem;
    flex: none;
    border-radius: 0.1rem;
    position: relative;
    img {
      display: block;
      height: 100%;
      width: 100%;
      object-fit: contain;
      background: #eeeeee;
    }
    .icon-play {
      display: inline-block;
      width: 0.44rem;
      height: 0.44rem;
      position: absolute;
      top: 0.4rem;
      left: 50%;
      transform: translate3d(-50%, 0, 0);
      background: url("../../assets/images/icon_vedio.png") no-repeat center;
      background-size: 100%;
    }
  }
  .work-info {
    display: flex;
    flex-direction: column;
    margin-right: 0.32rem;
    overflow: hidden;
    flex: 1;
    .topic-title {
      font-family: PingFangSC-Regular;
      font-size: 0.36rem;
      color: #333333;
      line-height: 0.5rem;
      margin-bottom: 0.1rem;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .reportor-info {
      display: flex;
      align-items: center;
      margin-bottom: 0.1rem;
      .reportor-name {
        flex: none;
        max-width: 1.44rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &.only-name {
          flex: 1;
          max-width: 100%;
        }
      }
      .icon-point {
        width: 0.06rem;
        height: 0.06rem;
        border-radius: 50%;
        background: #666666;
        flex: none;
        margin: 0 0.1rem;
      }
      .reportor-school {
        flex: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .guide-teacher {
      .label {
        margin-right: 0.1rem;
      }
    }

    .gray {
      font-family: PingFangSC-Regular;
      font-size: 0.26rem;
      color: #999999;
      line-height: 0.37rem;
    }
  }
  .praise-wrapper {
    width: 1.1rem;
    height: 1.1rem;
    border-radius: 50%;
    background: url("../../assets/images/btn_like_bg.png") no-repeat center;
    background-size: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: none;
    .heart-wrapper {
      margin-top: 0.19rem;
      width: 0.34rem;
      height: 0.34rem;
      position: relative;
    }
    .icon-heart {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      width: 100%;
      height: 100%;
      background: url("../../assets/images/icon_like_n.png") no-repeat center;
      background-size: 100%;
      &.active {
        background: url("../../assets/images/icon_like_s.png") no-repeat center;
        background-size: 100%;
      }
    }
    .praise-count {
      margin-top: 0.05rem;
      font-family: PingFangSC-Regular;
      font-size: 0.24rem;
      color: #666666;
      line-height: 0.33rem;
    }
  }
}
.fade-toggle-enter-active {
  animation: toggleScale 0.3s ease-in-out;
}
.fade-toggle-leave-active {
  transition: opacity 0.3s;
}
.fade-toggle-leave {
  opacity: 1;
}
.fade-toggle-leave-to {
  opacity: 0;
}
@keyframes toggleScale {
  0% {
    transform: scale3d(0.6, 0.6, 1);
    opacity: 0.3;
  }
  75% {
    transform: scale3d(1.2, 1.2, 1);
    opacity: 1;
  }
  100% {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}
</style>
